const initPostsSectionCursor = () => {
  let postCards = document.querySelectorAll('.post-card');

  if (!postCards) {
    return;
  }

  const updateCursorPosition = (cursor, event) => {
    cursor.style.top = `${event.clientY}px`;
    cursor.style.left = `${event.clientX}px`;
  };

  postCards.forEach((card) => {
    const cardCustomCursor = card.querySelector('.cursor');

    card.addEventListener('mouseover', (e) => {
      if (e.target.closest('.post-tags')) {
        cardCustomCursor.classList.add('cursor--hide');
      } else {
        cardCustomCursor.classList.remove('cursor--hide');
      }

      updateCursorPosition(cardCustomCursor, e);
    });

    card.addEventListener('mousemove', (e) => {
      if (e.target.closest('.post-tags')) {
        cardCustomCursor.classList.add('cursor--hide');
      } else {
        cardCustomCursor.classList.remove('cursor--hide');
      }

      updateCursorPosition(cardCustomCursor, e);
    });
  });
};

export { initPostsSectionCursor };
